import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { notificationsService } from "../notifications/notificationsService";
import { Box, Typography, List, ListItem, ListItemText, Badge, Button, IconButton, Select, MenuItem, FormControlLabel, Switch, Paper, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";

const Notifications = () => {
    const { currentUser } = useAuth();
    const { t } = useTranslation();
    const [notifications, setNotifications] = useState([]);
    const [type, setType] = useState("");
    const [onlyUnread, setOnlyUnread] = useState(false);
    const [loading, setLoading] = useState(true);

    const fetchNotifications = async () => {
        if (currentUser) {
            setLoading(true);
            const notifs = await notificationsService.getNotificationsForUser(currentUser.uid, { onlyUnread, type });
            setNotifications(notifs);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchNotifications();
    // eslint-disable-next-line
  }, [currentUser, onlyUnread, type]);

    const handleMarkAsRead = async (notifId) => {
        await notificationsService.markAsRead(notifId);
        fetchNotifications();
    };

    return (
        <Box sx={{ maxWidth: 700, mx: "auto", mt: 4, mb: 4 }}>
            <Typography variant="h4" sx={{ mb: 3 }}>{t("notifications.title", "Notifications")}</Typography>
            <Paper sx={{ p: 2, mb: 2 }}>
                <Box sx={{ display: "flex", gap: 2, alignItems: "center", mb: 2 }}>
                    <FormControlLabel
                        control={<Switch checked={onlyUnread} onChange={e => setOnlyUnread(e.target.checked)} />}
                        label={t("notifications.onlyUnread", "Only Unread")}
                    />
                    <Select
                        value={type}
                        onChange={e => setType(e.target.value)}
                        displayEmpty
                        sx={{ minWidth: 180 }}
                    >
                        <MenuItem value="">{t("notifications.allTypes", "All Types")}</MenuItem>
                        <MenuItem value="general">{t("notifications.general", "General")}</MenuItem>
                        <MenuItem value="opportunity">{t("notifications.opportunity", "Opportunity")}</MenuItem>
                        <MenuItem value="investment">{t("notifications.investment", "Investment")}</MenuItem>
                        {/* Add more types as needed */}
                    </Select>
                    <Button onClick={fetchNotifications}>{t("notifications.refresh", "Refresh")}</Button>
                </Box>
                <Divider sx={{ mb: 2 }} />
                <List>
                    {loading ? (
                        <ListItem><ListItemText primary={t("notifications.loading", "Loading...")} /></ListItem>
                    ) : notifications.length === 0 ? (
                        <ListItem><ListItemText primary={t("notifications.none", "No notifications found.")} /></ListItem>
                    ) : notifications.map(n => (
                        <ListItem key={n.id} sx={{ opacity: n.read ? 0.6 : 1 }}
                            secondaryAction={
                                !n.read ? (
                                    <IconButton edge="end" onClick={() => handleMarkAsRead(n.id)}>
                                        <MarkEmailReadIcon />
                                    </IconButton>
                                ) : null
                            }
                        >
                            <ListItemText
                                primary={n.message}
                                secondary={new Date(n.date).toLocaleString()}
                            />
                            {!n.read && <Badge color="primary" variant="dot" />}
                        </ListItem>
                    ))}
                </List>
            </Paper>
        </Box>
    );
};

export default Notifications; 